/** One sentence on what the search-terms list is for, shared by the practice and agency views. */
export const SEARCH_TERMS_DESCRIPTION =
  'The searches patients use to find a practice like yours — Sam checks where you rank for each one and writes content and Google posts to move them up.';

/** How to enter a term: the service only. The backend strips location words and matches every
 *  variation (searchTermMatching.ts). */
export const SEARCH_TERMS_INPUT_HINT =
  'Enter the service only, like "emergency dentist". Location and "near me" variations are covered automatically.';
